import type { ButtonHTMLAttributes } from "react";

/**
 * 共有ボタン（D-82・デモ `assets/app.css` の `.btn` 3階層＋黄CTA）。
 *
 * ★**`width: 100%` を既定にしない**（2026-07-30・T-D56）＝以前は既定で全幅だったため、
 * 一覧の行やヘッダーに置く用途に使えず、各ページが `formStyles.ts` の primaryButton /
 * ghostButton や画面内 const を自作していた（＝ボタンの見た目が画面ごとにバラバラになった原因）。
 * フォームの送信ボタンのように全幅にしたいときだけ `fullWidth` を付ける。
 *
 * ★`accent`（黄）は**承認＝人が確定する操作の専用色**（LC-02）。どこにでも黄を使うと
 * 「ここが確定ボタン」という意味が薄れるので、レビューで弾く。
 *
 * 見た目は `kit.css` の `.kz-btn`（:hover / :disabled が inline style では書けないため）。
 */
type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost" | "accent" | "default";
  size?: "md" | "sm";
  fullWidth?: boolean;
  busy?: boolean;
};

export function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  busy = false,
  className,
  children,
  ...rest
}: Props) {
  const classes = [
    "kz-btn",
    variant !== "default" ? `kz-btn--${variant}` : "",
    size === "sm" ? "kz-btn--sm" : "",
    fullWidth ? "kz-btn--block" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button {...rest} className={classes} disabled={rest.disabled || busy}>
      {busy ? "処理中…" : children}
    </button>
  );
}
